import * as React from "react";
import { Link } from "react-router-dom";
import { Patient } from "../../patient/types";

interface StoreProps {
  patient: Patient | null;
}

interface DispatchProps {
  scheduleVideoChat: (file: FormData) => void;
}

interface OwnState {
  submitDisabled: boolean;
}

type Props = StoreProps & DispatchProps;

class ScheduleVideoChat extends React.PureComponent<Props, OwnState> {
  constructor(props: Props) {
    super(props);

    this.state = {
      submitDisabled: true
    };
  }

  render() {
    return (
      <>
        <div className="video-container">
          <div className="information">
            <h1>Video Visit</h1>
            <div className="question">
              Would you like to start a video visit now, or schedule one for later?
            </div>
            <div className="options">
              <button>Now</button>
              <button>Later</button>
            </div>
            <div className="question mt-50">With an existing patient or a new one?</div>
            <div className="options">
              <button>
                Existing Patient <i className="fas fa-caret-down ml-5"></i>
              </button>
              <button>New Patient</button>
            </div>

            <div className="question mt-50">
              When would you like to schedule and for what duration?
            </div>
            <div className="options">
              <button>
                Today <i className="fas fa-caret-down ml-5"></i>
              </button>
              <button>
                9:00 AM <i className="fas fa-caret-down ml-5"></i>
              </button>
              <button>
                30 m <i className="fas fa-caret-down ml-5"></i>
              </button>
            </div>

            <div className="flex-justify-center mt-50">
              <button className="highlight">Schedule Appointment</button>
            </div>

            <div className="mt-50">
              We will send an SMS to the patient once the appointment is made.
            </div>
            <div className="mt-15">
              We will send another SMS message to both you and the patient 5 minutes before your
              scheduled appointment.
            </div>
            <div className="mt-15">
              <Link to="/appointments/">
                <button>
                  <i className="far fa-calendar-alt btn-icon"></i> View Appointments
                </button>
              </Link>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ScheduleVideoChat;
